
export default {

    postLogin(model) {
        return window.restApi.post('user/login', model);
    }
}
